(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rt-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const addBusinessDays = (startDate, count) => {
      const result = new Date(startDate);
      result.setHours(12, 0, 0, 0);

      while (count > 0) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();

        if (day !== 0 && day !== 6) {
          count -= 1;
        }
      }

      return result;
    };

    const initializeEstimate = (estimate) => {
      if (estimate.dataset.initialized === 'true') {
        return;
      }

      estimate.dataset.initialized = 'true';
      const days = Number.parseInt(estimate.dataset.businessDays, 10);
      const arrivalDate = addBusinessDays(new Date(), days);
      const currentDate = new Date();
      const formatOptions = {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      };

      if (arrivalDate.getFullYear() !== currentDate.getFullYear()) {
        formatOptions.year = 'numeric';
      }

      const dateOutput = estimate.querySelector('[data-rt-delivery-date]');
      if (dateOutput) {
        dateOutput.textContent = new Intl.DateTimeFormat(document.documentElement.lang || undefined, formatOptions).format(arrivalDate);
      }

      const formArea = estimate.closest('.t4s-product-form__variants');
      const variantSelect = formArea?.querySelector('select[name="id"]');

      if (!variantSelect) {
        return;
      }

      const syncAvailability = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const unavailable = !selectedOption || selectedOption.disabled || selectedOption.classList.contains('is--sold-out');
        estimate.hidden = unavailable;
      };

      variantSelect.addEventListener('change', syncAvailability);
      formArea.addEventListener('click', (event) => {
        if (event.target.closest('[data-swatch-item]')) {
          window.setTimeout(syncAvailability, 0);
        }
      });
      syncAvailability();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-rt-delivery-estimate]').forEach(initializeEstimate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-native-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rt-product-gallery')) {
    customElements.define('rt-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || !this.querySelector('[data-rt-variants]')) return;
        this.controller = new AbortController();
        this.data = JSON.parse(this.querySelector('[data-rt-variants]').textContent);
        this.slides = [...this.querySelectorAll('[data-rt-media]')];
        this.thumbs = [...this.querySelectorAll('[data-rt-thumb]')];
        this.track = this.querySelector('.rt-pg__track');
        this.dialog = this.querySelector('dialog');
        this.owner = this.closest('[data-product-featured]') || this.closest('.shopify-section');
        this.index = 0;
        const urlKey = src => String(src || '').replace(/^https?:/, '').split('?')[0];
        this.variantMedia = new Map(this.data.variants.map(variant => [String(variant.id), this.data.media.find(media => urlKey(media.src) === urlKey(variant.featured_image?.src))?.id]));
        this.starts = [...new Set([...this.variantMedia.values()].filter(Boolean))].map(id => this.slides.findIndex(slide => slide.dataset.rtMedia === id)).filter(index => index >= 0).sort((a,b) => a-b);
        const on = (target, type, fn, options={}) => target.addEventListener(type, fn, {...options, signal:this.controller.signal});
        this.on = on;
        on(this, 'click', event => {
          if(performance.now()<(this.suppressClickUntil||0)&&this.track.contains(event.target)){event.preventDefault();event.stopPropagation();return;}
          const button = event.target.closest('button');
          if (!button) return;
          if (button.matches('[data-step]')) this.select(this.index + Number(button.dataset.step));
          if (button.matches('[data-rt-thumb]')) this.select(this.visible.findIndex(slide => slide.dataset.rtMedia === button.dataset.rtThumb));
          if (button.matches('[data-thumb-step]')) {
            const scroller=this.querySelector('.rt-pg__thumbs');
            const horizontal=matchMedia('(max-width:767px)').matches;
            scroller.scrollBy({left:horizontal ? Number(button.dataset.thumbStep)*scroller.clientWidth*.8 : 0,top:horizontal ? 0 : Number(button.dataset.thumbStep)*scroller.clientHeight*.8,behavior:this.motion()});
          }
          if (button.matches('.rt-pg__image')) this.openZoom(button.closest('[data-rt-media]'));
          if (button.matches('.rt-pg__close')) this.dialog.close();
          if (button.matches('[data-zoom-step]')) this.stepZoom(Number(button.dataset.zoomStep));
          if (button.matches('.rt-pg__zoom-image')) button.classList.toggle('is-zoomed');
          if (button.matches('.rt-pg__play')) this.play(button.closest('[data-rt-media]'),true);
        });
        on(this.track, 'keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();this.select(this.index+(event.key==='ArrowRight'?1:-1));}
          if (event.key === 'Home' || event.key === 'End') {event.preventDefault();this.select(event.key==='Home'?0:this.visible.length-1);}
        });
        on(this.dialog,'keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.stepZoom(event.key==='ArrowRight'?1:-1);}});
        on(this.dialog,'close',()=>{document.documentElement.style.overflow=this.previousOverflow ?? '';this.zoomOpener?.focus({preventScroll:true});});
        on(this.track,'scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>this.syncScroll());},{passive:true});
        on(this.track,'dragstart',event=>event.preventDefault());
        on(this.track,'pointerdown',event=>{
          this.stopHover();
          if(event.pointerType==='mouse'&&event.button===0&&!event.target.closest('video,iframe,model-viewer'))this.dragState={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft,moved:false};
        });
        on(this.track,'pointermove',event=>{
          if(this.dragState&&event.pointerId===this.dragState.id){
            const delta=event.clientX-this.dragState.x;
            if(Math.abs(delta)>6)this.dragState.moved=true;
            if(this.dragState.moved){event.preventDefault();this.track.setPointerCapture(event.pointerId);this.track.scrollLeft=this.dragState.left-delta;}
            return;
          }
          if(event.pointerType!=='mouse'||!matchMedia('(min-width:768px) and (hover:hover) and (pointer:fine)').matches||this.dialog.open||event.buttons||performance.now()<(this.hoverAfter||0))return;
          if(event.target.closest('video,iframe,model-viewer'))return;
          if(!this.visible.length)return;
          const rect=this.track.getBoundingClientRect();
          const start=Math.min(this.visible[0].getBoundingClientRect().width,rect.width*.6);
          const end=rect.width*.94;
          const ratio=Math.max(0,Math.min(1,(event.clientX-rect.left-start)/(end-start)));
          this.hoverTarget=ratio*Math.max(0,this.track.scrollWidth-this.track.clientWidth);
          if(!this.hoverFrame){this.hoverTime=performance.now();this.hoverFrame=requestAnimationFrame(time=>this.animateHover(time));}
        });
        const endDrag=event=>{if(!this.dragState||event.pointerId!==this.dragState.id)return;if(this.dragState.moved)this.suppressClickUntil=performance.now()+350;this.dragState=null;this.hoverAfter=performance.now()+350;if(this.track.hasPointerCapture(event.pointerId))this.track.releasePointerCapture(event.pointerId);};
        on(window,'pointerup',endDrag);
        on(window,'pointercancel',endDrag);
        on(this.track,'pointerleave',()=>this.stopHover());
        const thumbs=this.querySelector('.rt-pg__thumbs');
        on(thumbs,'scroll',()=>this.updateThumbArrows(),{passive:true});
        const queue=()=>{clearTimeout(this.variantTimer);this.variantTimer=setTimeout(()=>this.syncVariant(),80);};
        on(this.owner,'change',queue);
        on(this.owner,'click',event=>{if(event.target.closest('.t4s-swatch__item,select,input'))queue();});
        on(window,'popstate',queue);
        on(document,'variant:change',queue);
        this.observer=new MutationObserver(queue);
        const select=this.owner.querySelector('select[name="id"]');
        if(select)this.observer.observe(select,{subtree:true,attributes:true,attributeFilter:['selected','value']});
        this.resizeObserver=new ResizeObserver(()=>{if(this.visible?.length)this.select(this.index,false);});
        this.resizeObserver.observe(this.track);
        this.applyVariant(this.dataset.selected);
        this.poll=setInterval(()=>{if(!document.hidden)this.syncVariant();},300);
      }
      hydrate(container){
        container.querySelectorAll('template[data-rt-poster-template]').forEach(template=>template.replaceWith(template.content.cloneNode(true)));
      }
      motion(){return matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';}
      stopHover(){cancelAnimationFrame(this.hoverFrame);this.hoverFrame=null;this.hoverTarget=null;}
      animateHover(time){
        if(this.hoverTarget===null)return;
        const elapsed=Math.min(64,Math.max(0,time-this.hoverTime));
        this.hoverTime=time;
        const distance=this.hoverTarget-this.track.scrollLeft;
        const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
        if(reduce||Math.abs(distance)<.5){this.track.scrollLeft=this.hoverTarget;this.hoverFrame=null;return;}
        this.track.scrollLeft+=distance*(1-Math.exp(-elapsed/40));
        this.hoverFrame=requestAnimationFrame(next=>this.animateHover(next));
      }
      updateThumbArrows(){
        const thumbs=this.querySelector('.rt-pg__thumbs'),horizontal=matchMedia('(max-width:767px)').matches;
        const position=horizontal?thumbs.scrollLeft:thumbs.scrollTop;
        const max=horizontal?thumbs.scrollWidth-thumbs.clientWidth:thumbs.scrollHeight-thumbs.clientHeight;
        this.querySelector('.rt-pg__thumb-prev').hidden=position<2;
        this.querySelector('.rt-pg__thumb-next').hidden=position>=max-2;
      }
      syncVariant(){
        const input=this.owner.querySelector('select[name="id"],input[name="id"]');
        const id=input?.value;
        if(id && id!==this.currentVariant && this.variantMedia.has(String(id)))this.applyVariant(id);
      }
      applyVariant(id){
        this.hoverAfter=performance.now()+500;
        this.currentVariant=String(id);
        let mediaId=this.variantMedia.get(this.currentVariant);
        if(!mediaId){
          const variant=this.data.variants.find(item=>String(item.id)===this.currentVariant);
          const colorIndex=this.data.options.findIndex(option=>/colou?r/i.test(option));
          if(variant && colorIndex>=0){const related=this.data.variants.find(item=>item.options[colorIndex]===variant.options[colorIndex]&&this.variantMedia.get(String(item.id)));mediaId=related&&this.variantMedia.get(String(related.id));}
        }
        const start=this.slides.findIndex(slide=>slide.dataset.rtMedia===mediaId);
        const next=this.starts.find(index=>index>start) ?? this.slides.length;
        const common=this.starts.length?this.slides.slice(0,this.starts[0]):[];
        this.visible=start>=0?[...this.slides.slice(start,next),...common]:[...this.slides];
        const visibleIds=new Set(this.visible.map(slide=>slide.dataset.rtMedia));
        this.slides.forEach(slide=>{slide.hidden=!visibleIds.has(slide.dataset.rtMedia);this.pause(slide);});
        this.thumbs.forEach(thumb=>thumb.hidden=!visibleIds.has(thumb.dataset.rtThumb));
        this.visible.forEach(slide=>this.hydrate(slide));
        this.thumbs.filter(thumb=>visibleIds.has(thumb.dataset.rtThumb)).forEach(thumb=>this.hydrate(thumb));
        this.visible.forEach((slide,index)=>{slide.style.order=String(index);this.thumbs.find(thumb=>thumb.dataset.rtThumb===slide.dataset.rtMedia).style.order=String(index);});
        if(this.dialog.open)this.dialog.close();
        this.select(0,false);
        cancelAnimationFrame(this.variantFrame);
        this.variantFrame=requestAnimationFrame(()=>this.select(0,false));
      }
      select(index,animate=true){
        if(!this.visible.length)return;
        this.stopHover();
        this.index=(index+this.visible.length)%this.visible.length;
        const slide=this.visible[this.index];
        const center=matchMedia('(min-width:768px)').matches?(this.track.clientWidth-slide.getBoundingClientRect().width)/2:0;
        const left=slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-center;
        this.track.scrollTo({left,behavior:animate?this.motion():'instant'});
        this.update();
      }
      syncScroll(){
        if(!this.visible?.length)return;
        const bounds=this.track.getBoundingClientRect();
        const desktop=matchMedia('(min-width:768px)').matches;
        const left=bounds.left+(desktop?bounds.width/2:0);
        let closest=0,distance=Infinity;
        this.visible.forEach((slide,index)=>{const r=slide.getBoundingClientRect();const d=Math.abs(r.left+(desktop?r.width/2:0)-left);if(d<distance){distance=d;closest=index;}});
        if(closest!==this.index){this.index=closest;this.update();}
      }
      update(){
        const active=this.visible[this.index];
        this.querySelector('.rt-pg__count').textContent=`${this.index+1} / ${this.visible.length}`;
        this.thumbs.forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb.dataset.rtThumb===active.dataset.rtMedia)));
        const thumb=this.thumbs.find(item=>item.dataset.rtThumb===active.dataset.rtMedia);
        const scroller=this.querySelector('.rt-pg__thumbs');
        const horizontal=matchMedia('(max-width:767px)').matches;
        const a=thumb.getBoundingClientRect(),b=scroller.getBoundingClientRect();
        if(horizontal&&(a.left<b.left||a.right>b.right))scroller.scrollLeft+=a.left-b.left;
        if(!horizontal&&(a.top<b.top||a.bottom>b.bottom))scroller.scrollTop+=a.top-b.top;
        this.updateThumbArrows();
        this.slides.forEach(slide=>{if(slide!==active)this.pause(slide);});
        if(active.dataset.kind==='video'&&!matchMedia('(prefers-reduced-motion:reduce)').matches)this.play(active,false);
        this.querySelectorAll('[data-step]').forEach(button=>button.disabled=this.visible.length<2);
      }
      pause(slide){
        slide.querySelector('video')?.pause();
        const frame=slide.querySelector('iframe');
        if(frame){frame.remove();const button=slide.querySelector('.rt-pg__play');if(button)button.hidden=false;}
      }
      play(slide,userInitiated){
        let media=slide.querySelector('video,iframe,model-viewer');
        if(!media){slide.append(slide.querySelector('template').content.cloneNode(true));media=slide.querySelector('video,iframe,model-viewer');}
        if(!media)return;
        slide.querySelector('.rt-pg__play').hidden=true;
        if(media.tagName==='VIDEO'){media.muted=!userInitiated;media.play().catch(()=>{});}
        if(media.tagName==='MODEL-VIEWER'&&window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0'}],()=>{});
      }
      openZoom(slide){
        this.stopHover();
        this.zoomSlides=this.visible.filter(item=>item.dataset.kind==='image');
        this.zoomIndex=this.zoomSlides.indexOf(slide);
        this.zoomOpener=slide.querySelector('button');
        this.showZoom();
        this.previousOverflow=document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';
        this.dialog.showModal();
        this.dialog.querySelector('.rt-pg__close').focus();
      }
      stepZoom(step){this.zoomIndex=(this.zoomIndex+step+this.zoomSlides.length)%this.zoomSlides.length;this.showZoom();}
      showZoom(){
        const source=this.zoomSlides[this.zoomIndex].querySelector('.rt-pg__image');
        const image=this.dialog.querySelector('img');
        image.src=source.dataset.full;image.alt=source.querySelector('img').alt;
        this.dialog.querySelector('.rt-pg__zoom-image').classList.remove('is-zoomed');
        this.querySelector('.rt-pg__zoom-count').textContent=`${this.zoomIndex+1} / ${this.zoomSlides.length}`;
      }
      disconnectedCallback(){
        this.stopHover();
        if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow??'';}
        this.controller?.abort();this.controller=null;this.observer?.disconnect();this.resizeObserver?.disconnect();clearInterval(this.poll);clearTimeout(this.variantTimer);cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.variantFrame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-variant-availability"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-rt-variant-availability]';

    const initialize = (root) => {
      if (root.dataset.rtVariantReady === 'true') return;

      const form = document.getElementById(root.dataset.formId);
      const json = root.querySelector('[data-rt-variant-json]');
      const status = root.querySelector('[data-rt-variant-status]');

      if (!form || !json || !status) return;

      let variants;

      try {
        variants = JSON.parse(json.textContent);
      } catch (error) {
        return;
      }

      const groups = Array.from(form.querySelectorAll('[data-swatch-option]')).sort(
        (first, second) => Number(first.dataset.id) - Number(second.dataset.id)
      );

      if (!groups.length) return;

      const selectedValues = () =>
        groups.map((group) => {
          const selected = group.querySelector('[data-swatch-item].is--selected');
          return selected ? selected.dataset.value : '';
        });

      const candidateIsAvailable = (optionIndex, value, selected) =>
        variants.some((variant) => {
          if (!variant.available || variant.options[optionIndex] !== value) return false;

          for (let index = 0; index < optionIndex; index += 1) {
            if (selected[index] && variant.options[index] !== selected[index]) return false;
          }

          return true;
        });

      const update = () => {
        const selected = selectedValues();

        groups.forEach((group, optionIndex) => {
          group.querySelectorAll('[data-swatch-item]').forEach((item) => {
            const available = candidateIsAvailable(optionIndex, item.dataset.value, selected);
            item.classList.toggle('rt-is-unavailable', !available);
            item.setAttribute('aria-disabled', String(!available));
          });
        });

        const complete = selected.every(Boolean);
        const variant = complete
          ? variants.find((item) =>
              item.options.every((value, index) => value === selected[index])
            )
          : null;

        status.classList.remove('is-sold-out', 'is-unavailable');

        if (!complete || !variant) {
          status.textContent = root.dataset.unavailableText;
          status.classList.add('is-unavailable');
        } else if (!variant.available) {
          status.textContent = root.dataset.soldOutText;
          status.classList.add('is-sold-out');
        } else {
          status.textContent = root.dataset.availableText;
        }
      };

      const queueUpdate = () => {
        window.setTimeout(update, 0);
        window.setTimeout(update, 120);
      };

      form.addEventListener(
        'click',
        (event) => {
          const item = event.target.closest('[data-swatch-item]');

          if (item && item.classList.contains('rt-is-unavailable')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          queueUpdate();
        },
        true
      );

      form.addEventListener('change', queueUpdate);
      document.addEventListener('variant:change', queueUpdate);
      document.addEventListener('variant:changed', queueUpdate);

      root.dataset.rtVariantReady = 'true';
      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeAll();
    document.addEventListener('DOMContentLoaded', () => initializeAll());
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
